import { render, staticRenderFns } from "./columnstore_column_histogram.vue?vue&type=template&id=452afa18&"
import script from "./columnstore_column_histogram.vue?vue&type=script&lang=js&"
export * from "./columnstore_column_histogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports